import { render, staticRenderFns } from "./ToothPiece.vue?vue&type=template&id=3e7b308f&"
import script from "./ToothPiece.vue?vue&type=script&lang=js&"
export * from "./ToothPiece.vue?vue&type=script&lang=js&"
import style0 from "./ToothPiece.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports